import type { UseQueryResult } from '@tanstack/react-query';

import { useQuery } from '@tanstack/react-query';

import type { InvoiceFilters } from '../../api/get-invoice-filters/getInvoiceFilters.types';

import { getInvoiceFilters } from '../../api/get-invoice-filters/getInvoiceFilters';

export function useInvoiceFilters(
  organizationId: string
): UseQueryResult<InvoiceFilters, Error> {
  return useQuery<InvoiceFilters, Error>({
    queryKey: ['invoices', 'filters', organizationId],
    queryFn: (): Promise<InvoiceFilters> => getInvoiceFilters(organizationId),
    enabled: !!organizationId,
    staleTime: 10 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
